export default "__VITE_ASSET__bhCt3szC__"